import React from 'react';
import PropTypes from 'prop-types';
import { PhotoView } from 'react-photo-view';
import MenuButton from './MenuButton';
import { SMALL_ICON_SIZE } from '../../../../../constants/theme';

const Card = ({
  img, index, siteId = null, openIndex = null, setOpenIndex, getActionItems,
}) => {
  const imageSrc = typeof img.image === 'string' ? img.image : img.image?.url;

  return (
    <div
      className="relative rounded-md overflow-hidden shadow-md w-71"
    >
      <div className="aspect-w-16 aspect-h-10">
        <PhotoView src={imageSrc}>
          <img
            src={imageSrc}
            className="w-full h-full object-cover"
            alt=""
          />
        </PhotoView>
      </div>

      {index === 0 && (
        <div className="absolute top-2 left-2 bg-vamos-true-white text-vamos-black text-base p-2 rounded-full inline-flex justify-center items-center font-normal font-sans">
          Cover photo
        </div>
      )}

      <div className="absolute top-2 right-2">
        <MenuButton
          items={getActionItems(img.id)}
          iconSize={SMALL_ICON_SIZE}
          isNewSite={!siteId}
          isShow={openIndex === index}
          onToggle={(isOpen) => setOpenIndex(isOpen ? index : null)}
        />
      </div>
    </div>
  );
};

Card.propTypes = {
  img: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  siteId: PropTypes.number,
  openIndex: PropTypes.number,
  setOpenIndex: PropTypes.func.isRequired,
  getActionItems: PropTypes.func.isRequired,
};

export default Card;
